import React, { useState, useRef } from 'react';
import { useClickAway } from 'react-use';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { NavLink } from 'react-router-dom';
import { IconUpOpen, IconDownOpen } from '../../index';
import * as Icons from '../Icon';
export const DropdownItem = ({
  children,
  to,
  onClick,
  className = '',
  style = {}
}) => {
  return to ? /*#__PURE__*/React.createElement(NavLink, {
    to: to,
    exact: true,
    activeClassName: "dropdown__item--active",
    onClick: onClick
  }, /*#__PURE__*/React.createElement("div", {
    className: `dropdown__item ${className}`,
    style: style
  }, children)) : /*#__PURE__*/React.createElement("div", {
    className: `dropdown__item ${className}`,
    style: style,
    onClick: onClick
  }, children);
};
export const Dropdown = ({
  children,
  label,
  icon,
  iconSize,
  iconColor,
  customIcon,
  isActive,
  menuPosition,
  isMenuOverlayed,
  description,
  className = '',
  style = {}
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const componentName = `Icon${icon}`;
  const IconComponent = icon && Icons[componentName];

  if (icon && !IconComponent) {
    console.error("Icon couldn't be found:", icon);
  }

  const onOutsideClick = () => {
    setIsOpen(false);
  };

  const onClick = () => children ? setIsOpen(!isOpen) : setIsOpen(false);

  useClickAway(dropdownRef, onOutsideClick);
  return /*#__PURE__*/React.createElement("div", {
    className: `dropdown ${className}`,
    style: style,
    onClick: onClick,
    ref: dropdownRef
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames('dropdown__button', {
      'dropdown__button--overlayed': isOpen && isMenuOverlayed
    })
  }, customIcon ? customIcon : icon && /*#__PURE__*/React.createElement(IconComponent, {
    className: classnames('dropdown__button-icon', {
      'dropdown__button-icon--no-label': !label
    }),
    color: isActive ? 'primary' : iconColor || 'black',
    size: iconSize
  }), label && /*#__PURE__*/React.createElement("div", {
    className: classnames('dropdown__button-label', {
      'dropdown__button-label--active': isActive
    })
  }, label), isOpen ? /*#__PURE__*/React.createElement(IconUpOpen, {
    className: classnames('dropdown__button-arrow', {
      'dropdown__button-arrow--no-label': !label
    }),
    color: "grey-800",
    size: 11
  }) : /*#__PURE__*/React.createElement(IconDownOpen, {
    className: classnames('dropdown__button-arrow', {
      'dropdown__button-arrow--no-label': !label
    }),
    color: "grey-800",
    size: 11
  })), /*#__PURE__*/React.createElement("div", {
    className: classnames('dropdown__menu', `dropdown__menu--${menuPosition}`, {
      [`dropdown__menu--overlayed`]: isMenuOverlayed,
      [`dropdown__menu--${menuPosition}--overlayed`]: isMenuOverlayed
    }),
    style: {
      display: isOpen ? 'block' : 'none'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames('dropdown__menu-content', {
      'dropdown__menu-content--overlayed': isMenuOverlayed
    })
  }, description && /*#__PURE__*/React.createElement("div", {
    className: "dropdown__menu-description"
  }, description), children)));
};
Dropdown.defaultProps = {
  iconSize: 14,
  menuPosition: 'right',
  isMenuOverlayed: false,
  isActive: false
};
Dropdown.propTypes = {
  icon: PropTypes.string,
  iconSize: PropTypes.number,
  iconColor: PropTypes.string,
  isActive: PropTypes.bool,
  label: PropTypes.string,
  menuPosition: PropTypes.oneOf(['left', 'right']),
  isMenuOverlayed: PropTypes.bool,
  description: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object
};
DropdownItem.propTypes = {
  to: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string,
  style: PropTypes.object
};